// © Microsoft Corporation. All rights reserved.

import { customElement } from "@microsoft/fast-element";
import { MarketSelectorTemplate as template } from "./MarketSelector.template";
import { MarketSelectorStyles as styles } from "./MarketSelector.styles";
import { MarketSelector as MarketSelectorBase } from "./MarketSelector";
import { MarketSelectorProps } from "./Interfaces";
/**
 * Microsoft News market selector web component
 */
@customElement({
    name: "msn-market-selector",
    template,
    styles
})
class MsnMarketSelector extends MarketSelectorBase { }

export {
    MsnMarketSelector,
    MarketSelectorProps as MsnMarketSelectorProps
};
